module.exports = __webpack_public_path__ + "img/Ardunic Elements-27.6a8f470c.svg";